import React from 'react'
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import AddMoney from './addmoneycontent/addMoney';
import Footer from "../../components/footer";
// import CreditContent from './creditscontent/creditsContent';
const addmoney = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeader title="Add Money " />
    <AddMoney />
    {/* <CreditContent /> */}
    <Footer />
  </div>
  )
}

export default addmoney